import { render, staticRenderFns } from "./_rightPancake1 copy.vue?vue&type=template&id=3684069a&scoped=true&"
import script from "./_rightPancake1 copy.vue?vue&type=script&lang=js&"
export * from "./_rightPancake1 copy.vue?vue&type=script&lang=js&"
import style0 from "./_rightPancake1 copy.vue?vue&type=style&index=0&id=3684069a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684069a",
  null
  
)

export default component.exports